export default __webpack_public_path__ + "static/media/Icon-material-person.d0fa36d7.svg";